export default "__VITE_ASSET__CcwA9EUf__"